import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { useSearchParams } from "react-router-dom";

import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";
import Modal from "components/organisms/Modal";
import ModalComplete from "components/templates/editPassword/ModalComplete";

import useEditUserPassword from "apis/mutations/user/useEditUserPassword";
import useEditCompanyPassword from "apis/mutations/company/useEditCompanyPassword";

import authAtom from "stores/auth";
import REGEXP from "datas/regexp";

const Form = () => {
  const [searchParams] = useSearchParams();
  const queryList = [...searchParams];

  const setAuth = useSetRecoilState(authAtom);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [errorMessage, setErrorMessage] = useState<
    undefined | string | string[]
  >("");

  const token = queryList.find((query) => query[0] === "token")?.[1];
  const type = queryList.find((query) => query[0] === "type")?.[1];

  // 비밀번호 변경하기 api - 일반회원
  const editUserPassword = useEditUserPassword({
    token,
    onError: (m) => setErrorMessage(m),
  });

  // 비밀번호 변경하기 api - 전문가회원
  const editCompanyPassword = useEditCompanyPassword({
    token,
    onError: (m) => setErrorMessage(m),
  });

  // 비밀번호 변경하기
  const handleClickEditPassword = (onOpen: () => void) => {
    if (!REGEXP.password.test(password)) {
      setErrorMessage(
        "8자리 이상/대문자,소문자,숫자, 특수문자(!@#$%^&*?_~+=(){}.,;:-<>)중 3 종류 조합으로 비밀번호를 작성해주세요."
      );
      return false;
    }

    if (password !== passwordConfirm) {
      return setErrorMessage("비밀번호가 일치하지 않습니다.");
    }

    if (type === "user") {
      editUserPassword({ password }, { onSuccess: () => onOpen() });
    } else {
      editCompanyPassword({ password }, { onSuccess: () => onOpen() });
    }
  };

  return (
    <form>
      <InputText
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="새 비밀번호 입력"
        type="password"
        className={{ container: "mb-3" }}
        shape="square"
      />
      <InputText
        value={passwordConfirm}
        onChange={(e) => setPasswordConfirm(e.target.value)}
        placeholder="새 비밀번호 재입력"
        type="password"
        shape="square"
      />
      {errorMessage && (
        <p className="mt-1 ml-2 text-error-active">{errorMessage}</p>
      )}

      <Modal
        activator={(onOpen) => (
          <Btn.Blue
            onClick={() => handleClickEditPassword(onOpen)}
            size="large"
            className="w-full mt-5 mx-auto"
            type="button"
          >
            변경하기
          </Btn.Blue>
        )}
        modal={(onClose) => (
          <ModalComplete
            onClick={() => {
              localStorage.removeItem("TOKEN");
              setAuth({ isLogin: false, type: "" });
              window.location.href = "/login";
              onClose();
            }}
          />
        )}
      />
    </form>
  );
};

export default Form;
